<template>
  <div class="home-spain">
    <div class="util-snippet">
      <div
        itemscope
        itemtype="https://schema.org/Organization"
      >
        <span itemprop="name">Spalopia, S.L.</span>

        <div
          itemprop="address"
          itemscope
          itemtype="https://schema.org/PostalAddress"
        >
          <span itemprop="streetAddress">Avenida Sor Soledad Cobian, 3, 38300 - Orotava, La</span>
          <span itemprop="addressLocality">Canarias, España</span>
          <span itemprop="email">ayuda@spalopia.com</span>
        </div>
      </div>

      <div
        itemscope
        itemtype="https://schema.org/WebSite"
      >
        <link
          itemprop="url"
          :href="domain"
        >
      </div>
    </div>

    <div>
      <BenefitsCard
        class="only-desktop-block"
        :tags="['GIVINGS', 'BEST_PRICE', 'SAFE_PAYMENT']"
        :can-close="false"
        :is-title-displayed="false"
      />
    </div>

    <div class="home-spain__container">
      <div class="only-mobile home-spain__main-title">
        <Lang by-key="home-header-title" />
      </div>
    </div>

    <!-- isBlackFriday -->
    <div
      v-if="isBlackFriday"
      class="home-spain__container__small"
    >
      <Card
        class="home-spain__highlight-display black-friday-bg"
        mobile-with-border
        desktop-with-border
      >
        <div class="home-spain__highlight-display__side-texts">
          <p class="title">
            ¡APROVECHA EL BLACK FRIDAY!
          </p>

          <p class="subtitle">
            Pocas veces verás tantos descuentos en la web de Spalopia
          </p>

          <div>
            <p>
              ¡Aprovecha para darte un capricho o incluso regalar en Navidades!
            </p>
          </div>

          <div class="base-price">
            <span>
              Descuentos hasta del
            </span>
            <span class="base-price__price">40 %</span>
          </div>

          <div class="button">
            <SplNuxtLink
              is-external
              :to="promoBlackFridayLink"
            >
              <SplButton
                variant="acent"
                size="full"
              >
                VER TODAS LAS OFERTAS
              </SplButton>
            </SplNuxtLink>
          </div>
        </div>

        <div>
          <Card
            class="home-spain__highlight-display__side-details"
            mobile-with-border
            desktop-with-border
          >
            <div class="image">
              <img src="~/assets/images/home/promos/black-friday-promo.webp">
            </div>

            <p class="title">
              Aprovecha la época con más descuentos del año
            </p>

            <div class="subtitle">
              ¡Más de 100 promociones para elegir!
            </div>

            <div class="base-price">
              <span>
                <Lang by-key="from-value" />
              </span>
              <span class="base-price__price">28 €</span>
            </div>
          </Card>
        </div>
      </Card>
    </div>

    <!-- isChristmas -->
    <div
      v-else-if="isChristmas"
      class="home-spain__container__small"
    >
      <Card
        class="home-spain__highlight-display christmas-kings-bg"
        mobile-with-border
        desktop-with-border
      >
        <div class="home-spain__highlight-display__side-texts">
          <!-- TODO: Automatizar la semana de los Reyes Magos -->
          <!-- <p class="title">
            ¡SE ACERCAN LAS NAVIDADES!
          </p> -->
          <p class="title">
            ¡YA VIENEN LOS REYES!
          </p>

          <!-- <p class="subtitle">
            ¿Ya sabes qué vas a regalar este año tan especial a tu pareja, amigos y familiares?
          </p> -->
          <p class="subtitle">
            Todavía estás a tiempo de sorprender a tu pareja, amigos familiares con el regalo más preciado: Tiempo para ellos
          </p>

          <div>
            <p>
              ¡Hemos hecho una selección muy especial para acertar con los regalos!
            </p>
          </div>

          <div class="base-price">
            <span>
              Regala Bienestar desde
            </span>
            <span class="base-price__price">20€</span>
          </div>

          <div class="button">
            <SplNuxtLink
              is-external
              :to="promoChristmasLink"
            >
              <SplButton
                variant="acent"
                size="full"
              >
                VER TODAS LAS OPCIONES
              </SplButton>
            </SplNuxtLink>
          </div>
        </div>

        <div>
          <Card
            class="home-spain__highlight-display__side-details"
            mobile-with-border
            desktop-with-border
          >
            <!-- <div class="image">
              <img src="~/assets/images/home/promos/christmas-promo.webp">
            </div> -->
            <div class="image">
              <img src="~/assets/images/home/promos/regalo-reyes-masaje-oro.jpeg">
            </div>

            <p class="title">
              Este año regala un Bono de Spalopia y disfruta con sus caras cuando lo reciban
            </p>

            <div class="subtitle">
              ¡Más de 200 promociones para elegir!
            </div>

            <div class="base-price">
              <span>
                <Lang by-key="from-value" />
              </span>
              <span class="base-price__price">20 €</span>
            </div>
          </Card>
        </div>
      </Card>
    </div>

    <!-- isValentines -->
    <div
      v-else-if="isValentines"
      class="home-spain__container__small"
    >
      <HomePromoValentines />
    </div>

    <!-- isFathersDay -->
    <div
      v-else-if="isFathersDay"
      class="home-spain__container__small"
    >
      <HomePromoFathersDay />
    </div>

    <!-- isMothersDay -->
    <div
      v-else-if="isMothersDay"
      class="home-spain__container__small"
    >
      <HomePromoMothersDay />
    </div>

    <div
      v-else-if="isHolyWeek"
      class="home-spain__container__small"
    >
      <HomePromoHolyWeek />
    </div>

    <div
      v-else-if="isTeacherGift"
      class="home-spain__container__small"
    >
      <HomePromoTeacherGift />
    </div>

    <div
      v-else
      class="home-spain__container__small"
    >
      <HomePromoDefault />
    </div>

    <div class="home-spain__container">
      <BenefitsCard
        class="only-mobile"
        :tags="['GIVINGS-SMALL', 'BEST_PRICE', 'SAFE_PAYMENT']"
        :can-close="false"
        :is-title-displayed="false"
      />
    </div>

    <div class="home-spain__container home-spain__header-and-text">
      <div>
        <h2><Lang by-key="home-promo-section-1-title" /></h2>

        <p>
          <Lang by-key="home-promo-section-1-text" />
        </p>
      </div>
    </div>

    <div class="home-spain__container">
      <div class="home-spain__list-display-5">
        <div
          v-for="promo in promoLinksA"
          :key="promo.url"
          class="home-spain__list-display-5__item"
        >
          <SplNuxtLink
            :to="promo.url"
            is-external
          >
            <div class="home-spain__promo-item">
              <div>
                <div v-if="promo.imageKey">
                  <HomeImage :variant="promo.imageKey" />
                </div>

                <h3 class="home-spain__promo-item__title">
                  {{ promo.title }}
                </h3>
              </div>

              <div class="home-spain__promo-item__description">
                {{ promo.description }}
              </div>

              <SplButton
                variant="acent"
                size="full"
              >
                <Lang
                  by-key="see-more"
                  capitalize-first
                />
              </SplButton>
            </div>
          </SplNuxtLink>
        </div>
      </div>
    </div>

    <div class="home-spain__container home-spain__header-and-text">
      <div>
        <h2><Lang by-key="home-promo-section-2-title" /></h2>

        <p>
          <Lang by-key="home-promo-section-2-text" />
        </p>
      </div>
    </div>

    <div class="home-spain__container">
      <div class="home-spain__list-display-5">
        <div
          v-for="treatment in treatmentListA"
          :key="treatment.url"
          class="home-spain__list-display-5__item"
        >
          <SplNuxtLink
            :to="treatment.url"
            is-external
          >
            <div class="home-spain__promo-item">
              <div>
                <div v-if="treatment.imageKey">
                  <HomeImage :variant="treatment.imageKey" />
                </div>

                <h3 class="home-spain__promo-item__title">
                  {{ treatment.title }}
                </h3>
              </div>

              <div class="home-spain__promo-item__description">
                {{ treatment.description }}
              </div>

              <SplButton
                variant="acent"
                size="full"
              >
                <Lang
                  by-key="see-more"
                  capitalize-first
                />
              </SplButton>
            </div>
          </SplNuxtLink>
        </div>
      </div>
    </div>

    <div class="home-spain__container home-spain__header-and-text">
      <div>
        <h2><Lang by-key="home-promo-section-3-title" /></h2>

        <p>
          <Lang by-key="home-promo-section-3-text" />
        </p>
      </div>
    </div>

    <div class="home-spain__container">
      <div class="home-spain__list-display-5">
        <div
          v-for="promo in promoLinksB"
          :key="promo.url"
          class="home-spain__list-display-5__item"
        >
          <SplNuxtLink
            :to="promo.url"
            is-external
          >
            <div class="home-spain__promo-item">
              <div>
                <div v-if="promo.imageKey">
                  <HomeImage :variant="promo.imageKey" />
                </div>

                <h3 class="home-spain__promo-item__title">
                  {{ promo.title }}
                </h3>
              </div>

              <div class="home-spain__promo-item__description">
                {{ promo.description }}
              </div>

              <SplButton
                variant="acent"
                size="full"
              >
                <Lang
                  by-key="see-more"
                  capitalize-first
                />
              </SplButton>
            </div>
          </SplNuxtLink>
        </div>
      </div>
    </div>

    <div class="only-desktop-block">
      <Separator hide />
      <BenefitsCard
        :tags="['VALID_BONUSES', 'SUPPORT', 'GIVE_EXPERIENCIES']"
        :can-close="false"
        :is-title-displayed="false"
      />
      <Separator hide />
    </div>

    <div class="home-spain__container home-spain__header-and-text">
      <div>
        <h2><Lang by-key="home-promo-section-4-title" /></h2>

        <p>
          <Lang by-key="home-promo-section-4-text" />
        </p>
      </div>
    </div>

    <div
      v-if="shouldDisplayESLocs"
      class="home-spain__container"
    >
      <div class="home-spain__location-title">
        España
      </div>

      <div class="home-spain__list-display-4">
        <div
          v-for="location in esLocationLinks"
          :key="location.url"
          class="home-spain__list-display-4__item"
        >
          <SplNuxtLink
            :to="location.url"
            is-external
          >
            <div class="home-spain__location-item">
              <div class="home-spain__location-item__image-wrapper">
                <HomeImage :variant="location.imageKey" />
              </div>

              <SplButton
                variant="acent"
                size="full"
              >
                {{ location.title }}
              </SplButton>
            </div>
          </SplNuxtLink>
        </div>
      </div>
    </div>

    <div
      v-if="shouldDisplayPTLocs"
      class="home-spain__container"
    >
      <div class="home-spain__location-title">
        Portugal
      </div>

      <div class="home-spain__list-display-4">
        <div
          v-for="location in ptLocationLinks"
          :key="location.url"
          class="home-spain__list-display-4__item"
        >
          <SplNuxtLink
            :to="location.url"
            is-external
          >
            <div class="home-spain__location-item">
              <div class="home-spain__location-item__image-wrapper">
                <HomeImage :variant="location.imageKey" />
              </div>

              <SplButton
                variant="acent"
                size="full"
              >
                {{ location.title }}
              </SplButton>
            </div>
          </SplNuxtLink>
        </div>
      </div>
    </div>

    <Separator hide />

    <div class="home-spain__highlight">
      <div class="home-spain__container">
        <GiftCardMini />
      </div>
    </div>

    <Separator hide />

    <div class="home-spain__container__small">
      <NewsLetterSub />
    </div>

    <Separator hide />
  </div>
</template>

<script lang="ts">
import BenefitsCard from '~/core/components/spa/BenefitsCard.vue'
import GiftCardMini from '~/core/components/shared/GiftCardMini.vue'
import NewsLetterSub from '~/core/components/home/NewsLetterSub.vue'

import Separator from '~/core/components/shared/Separator.vue'
import Card from '~/core/components/shared/Card.vue'
import Badge from '~/core/components/shared/Badge.vue'
import SplNuxtLink from '~/core/components/shared/SplNuxtLink.vue'
import SplButton from '~/core/components/shared/form/SplButton.vue'
import SlideShow from '~/core/components/shared/gallery/SlideShow.vue'

import HomeImage from '~/core/components/home/HomeImage.vue'
import HomePromoDefault from '~/core/components/home/HomePromoDefault.vue'
import HomePromoValentines from '~/core/components/home/HomePromoValentines.vue'
import HomePromoFathersDay from '~/core/components/home/HomePromoFathersDay.vue'
import HomePromoMothersDay from '~/core/components/home/HomePromoMothersDay.vue'
import HomePromoHolyWeek from '~/core/components/home/HomePromoHolyWeek.vue'
import HomePromoTeacherGift from '~/core/components/home/HomePromoTeacherGift.vue'

import { getHomeMetadata } from '~/core/composable/home/useHomePageHeader'
import { useSessionLocation } from '~/core/composable/shared/useSessionLocation'
import { useLocatedLinks } from '~/core/composable/shared/useLocatedLinks'

import config from '~/core/ts/server-config'

definePageMeta({
  layout: 'home',
})

type PromoEntry = {
  title: string,
  imageKey?: string,
  description?: string,
  url: string,
}

export default defineNuxtComponent({
  components: {
    BenefitsCard,
    GiftCardMini,
    NewsLetterSub,
    Separator,
    Card,
    Badge,
    SplNuxtLink,
    SplButton,
    SlideShow,
    HomeImage,
    HomePromoDefault,
    HomePromoValentines,
    HomePromoFathersDay,
    HomePromoMothersDay,
    HomePromoHolyWeek,
    HomePromoTeacherGift,
  },
  async setup() {
    const route = useRoute()
    const uri = route.path
    useHead(getHomeMetadata(uri))

    const runtimeConfig = useRuntimeConfig()

    const domain = runtimeConfig.public.domain

    const isDev = runtimeConfig.public.isDev

    const isChristmas   = config.promos.isChristmas
    const isBlackFriday = config.promos.isBlackFriday
    const isValentines  = config.promos.isValentines
    const isFathersDay  = config.promos.isFathersDay
    const isMothersDay  = config.promos.isMothersDay
    const isHolyWeek    = config.promos.isHolyWeek
    const isTeacherGift = config.promos.isTeacherGift

    const sessionLocation = useSessionLocation()

    const promoLinksA: Array<PromoEntry> = ([
      {
        title: 'Spa',
        imageKey: 'spa',
        description: 'Relájate con circuito termal',
        url: '/promociones/circuito/',
      },
      {
        title: 'Spa + Gastro',
        imageKey: 'spa-gastro',
        description: 'Alimenta tu espítitu',
        url: '/promociones/circuito-spa-comida/',
      },
      {
        title: 'Spa + Masaje',
        imageKey: 'spa-masaje',
        description: 'Descanso y relax total',
        url: '/promociones/circuito-y-masaje/',
      },
      {
        title: 'Day Spa',
        imageKey: 'Daypass',
        description: 'Placer a día completo',
        url: '/promociones/daypass-spa/',
      },
      {
        title: 'Escapada Wellness',
        imageKey: 'spa-alojamiento',
        description: 'Relax full-time Spa + Hotel',
        url: '/escapadas-hotel-spa/',
      }
    ])

    const treatmentListA: Array<PromoEntry> = [
      {
        title: 'Hidroterapia',
        url: '/hidroterapia/',
        imageKey: 'Hidroterapia',
        description: 'Disfruta de un baño relajante',
      },
      {
        title: 'Masajes',
        url: '/masajes/',
        imageKey: 'Masajes',
        description: 'Libera tensiones',
      },
      {
        title: 'Faciales',
        url: '/tratamientos-faciales/',
        imageKey: 'Tratamientos-Faciales',
        description: 'Oxigena la cara',
      },
      {
        title: 'Corporales',
        url: '/tratamientos-corporales/',
        imageKey: 'Tratamientos-Corporales',
        description: 'Dale un nuevo brillo a tu piel',
      },
      {
        title: 'Rituales',
        url: '/rituales-belleza/',
        imageKey: 'Rituales-de-Belleza',
        description: 'Te mereces desconectar',
      },
    ]

    const promoLinksB: Array<PromoEntry> = ([
      {
        title: 'Spa en Pareja',
        imageKey: 'spa-pareja',
        description: 'Un momento único para dos',
        url: '/promociones/spa-en-pareja/',
      },
      {
        title: 'Spa Embarazadas',
        imageKey: 'spa-embarazada',
        description: 'Alivia tensiones y cansancio',
        url: '/promociones/spa-para-embarazadas/',
      },
      {
        title: 'Spa para Niños',
        imageKey: 'spa-kids',
        description: 'Descanso bien merecido',
        url: '/promociones/spa-para-ninos/',
      },
      {
        title: 'Spa Privado',
        imageKey: 'spa-privado',
        description: 'Paz de harmonía en pareja',
        url: '/promociones/spa-privado/',
      },
      {
        title: 'Masaje para dos',
        imageKey: 'masaje-dos',
        description: 'Relaja tu cuerpo en compañía',
        url: '/promociones/masaje-para-dos/',
      }
    ])

    const esLocationLinks: Array<PromoEntry> = ([
      {
        url: '/spa-balneario/tenerife/',
        imageKey: 'tenerife',
        title: 'Tenerife',
      },

      {
        url: '/spa-balneario/gran-canaria/',
        imageKey: 'gran-canaria',
        title: 'Gran Canaria',
      },

      {
        url: '/spa-balneario/granada/',
        imageKey: 'granada',
        title: 'Granada',
      },

      {
        url: '/spa-balneario/cadiz/',
        imageKey: 'cadiz',
        title: 'Cádiz',
      },

      {
        url: '/spa-balneario/mallorca/',
        imageKey: 'mallorca',
        title: 'Mallorca',
      },

      {
        url: '/spa-balneario/valencia/',
        imageKey: 'valencia',
        title: 'Valencia',
      },

      {
        url: '/spa-balneario/madrid/',
        imageKey: 'madrid',
        title: 'Madrid',
      },

      {
        url: '/spa-balneario/barcelona/',
        imageKey: 'barcelona',
        title: 'Barcelona',
      },
    ])

    const ptLocationLinks: Array<PromoEntry> = ([
      {
        url: '/escapadas-hotel-spa/lisboa/',
        imageKey: 'lisboa',
        title: 'Lisboa',
      },

      {
        url: '/escapadas-hotel-spa/oporto/',
        imageKey: 'oporto',
        title: 'Oporto',
      },

      {
        url: '/escapadas-hotel-spa/madeira/',
        imageKey: 'madeira',
        title: 'Madeira',
      },

      {
        url: '/escapadas-hotel-spa/acores/',
        imageKey: 'azores',
        title: 'Açores',
      },
    ])

    const shouldDisplayESLocs = computed(() => {
      const country = sessionLocation.storedLocationCountry.value

      if (!country) {
        return true
      }

      return country.country === 'ES'
    })

    const shouldDisplayPTLocs = computed(() => {
      const country = sessionLocation.storedLocationCountry.value

      if (!country) {
        return true
      }

      return country.country === 'PT'
    })

    const {
      baseSpaLink,
      promoBlackFridayLink,
      promoChristmasLink,
      fetchChristmasPromo
    } = useLocatedLinks()

    await fetchChristmasPromo()

    return {
      domain,

      isDev,

      isChristmas,
      isBlackFriday,
      isValentines,
      isFathersDay,
      isMothersDay,
      isHolyWeek,
      isTeacherGift,

      baseSpaLink,
      promoBlackFridayLink,
      promoChristmasLink,

      promoLinksA,
      treatmentListA,
      promoLinksB,

      shouldDisplayESLocs,
      shouldDisplayPTLocs,

      esLocationLinks,
      ptLocationLinks,
    }
  },
})
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  @apply opacity-100;
  @apply transition-all duration-500;
}
.fade-enter,
.fade-leave-to {
  @apply opacity-0;
  @apply mt-4;
}

.home-spain {
  @apply py-2;

  &__main-title {
    @apply text-center;

    @apply text-xl font-semibold;
    @apply text-spl-dark;

    @apply px-4;

    @apply pt-8;
    @apply pb-6;
  }

  &__location-title {
    @apply py-4 mb-2 mt-4;

    @apply font-bold;
    @apply text-2xl;

    @apply text-spl-primary-dark;

    @apply text-center;

    @apply border-b-1;

    @screen md {
      @apply border-b-0;
      @apply text-left;
    }
  }

  &__highlight {
    @apply bg-spl-gray-1;
  }

  &__container,
  &__container__small {
    @apply w-full;

    @apply pb-2;
    @apply px-2;

    @screen md {
      @apply px-6;
    }

    @screen lg {
      @apply w-11/12;
      @apply mx-auto;
    }
  }

  &__container__small {
    @screen lg {
      @apply w-3/4;
      @apply mx-auto;
    }

    @screen 2xl {
      @apply w-2/4;
      @apply mx-auto;
    }
  }

  &__header-and-text {
    @apply mt-16;
    @apply mb-12;

    h2 {
      @apply my-4;

      @apply text-spl-dark;
      @apply text-2xl;

      @apply font-bold;
    }

    p {
      @apply mb-2;
      @apply text-xl;

      @screen md {
        @apply w-2/3;
      }

      @screen lg {
        @apply w-1/2;
      }
    }
  }

  &__highlight-display {
    background-image: url('~/assets/images/slider/Slide2.webp');
    background-size: cover;

    background-color: rgba(12,12,12,.5);
    background-blend-mode: multiply;
  }

  &__highlight-display.black-friday-bg {
    background-image: url('~/assets/images/home/promos/black-friday-promo.webp');
    background-size: cover;

    background-color: rgba(12,12,12,.5);
    background-blend-mode: multiply;
  }

  &__highlight-display.christmas-bg {
    background-image: url('~/assets/images/home/promos/christmas-promo.webp');
    background-size: cover;

    background-color: rgba(12,12,12,.5);
    background-blend-mode: multiply;
  }

  &__highlight-display.christmas-kings-bg {
    background-image: url('~/assets/images/home/promos/regalo-reyes-piscina-spa.jpeg');
    // background-size: cover;
    background-position: 90%;

    background-color: rgba(12,12,12,.6);
    background-blend-mode: multiply;
  }

  &__highlight-display {
    @apply grid;
    @apply grid-cols-1;
    @apply grid-rows-2;
    @apply gap-5;

    @apply my-2;
    @apply p-12;

    @screen md {
      @apply my-4;
      @apply p-8;

      @apply grid-cols-2;
      @apply grid-rows-1;
    }

    @screen lg {
      @apply p-12;
    }

    &__side-texts {
      @apply text-white;

      @apply h-full;

      @apply flex;
      @apply flex-col;

      @apply justify-between;

      @apply gap-4;

      @apply py-12;

      .title {
        @apply text-4xl;
        @apply font-bold;
        @apply mb-2;
      }

      .subtitle {
        @apply text-3xl;
      }

      .base-price {
        @apply my-6;

        @apply flex;
        @apply items-center;
        @apply justify-center;
        @apply gap-2;

        @apply text-lg;

        &__price {
          @apply text-4xl;
          @apply font-bold;
        }
      }

      .button {
        @apply text-center;

        @apply px-0;
        @screen md {
          @apply px-8;
        }
      }
    }

    &__side-details {
      @apply bg-white;
      @apply h-full;

      @apply flex;
      @apply flex-col;

      @apply justify-between;

      @apply p-8;

      .image {
        img {
          @apply rounded-2xl;
          @apply w-full;
        }
      }

      .title {
        @apply font-bold;
        @apply text-spl-primary;

        @apply text-2xl;
        @apply my-1;
        @apply pt-2;
      }

      .subtitle {
        @apply text-lg;
        @apply text-spl-dark;
      }

      .base-price {
        @apply mt-4;

        @apply flex;
        @apply items-center;
        @apply justify-center;
        @apply gap-2;

        @apply text-lg;

        &__price {
          @apply text-spl-dark;

          @apply text-4xl;
          @apply font-bold;
        }
      }
    }
  }

  &__list-display-5 {
    // @apply w-full;

    @apply flex flex-row;

    @apply overflow-x-auto;
    @apply snap-mandatory;
    @apply snap-x;

    &__item {
      @apply flex-grow;
    }
  }

  &__list-display-4 {
    @apply w-full;

    @apply grid;
    @apply grid-cols-1;
    @apply gap-2;

    @screen sm {
      @apply grid-cols-2;
    }

    @screen md {
      @apply gap-6;
      @apply grid-cols-3;
    }

    @screen lg {
      @apply grid-cols-4;
    }

    &__item {
      // @apply flex-1;
    }
  }

  &__location-item {
    @apply text-spl-primary-dark;

    @apply w-full;
    @apply h-full;

    @apply flex;
    @apply flex-col;

    @apply justify-between;

    @apply px-6;
    @apply py-4;

    @screen md {
      @apply px-0;
      @apply py-0;

      @apply w-300p;
    }

    &__image {
      @apply w-full;
    }

    &__image-wrapper {
      @apply w-full;
      // @apply h-200p;

      @screen md {
        @apply h-150p;
      }

      @screen lg {
        @apply h-170p;
      }

      @apply overflow-hidden;

      img {
        @apply w-full;
      }
    }

    &__title {
      @apply pt-4;

      @apply text-xl;
      @apply font-bold;
    }

    &__description {
      @apply pt-2;
      @apply pb-4;

      @apply text-lg;
    }
  }

  &__promo-item {
    @apply text-spl-primary-dark;

    @apply w-300p;
    @apply h-full;

    @apply flex;
    @apply flex-col;

    @apply justify-between;

    @apply px-4;
    @apply py-2;

    @screen md {
      @apply px-2;
      @apply py-0;
    }

    &__image {
      @apply w-full;
    }

    &__image-wrapper {
      @apply w-full;
      @apply h-200p;

      @screen md {
        @apply h-150p;
      }

      @screen lg {
        @apply h-170p;
      }

      @apply overflow-hidden;

      img {
        @apply w-full;
      }
    }

    &__title {
      @apply pt-4;

      @apply text-xl;
      @apply font-bold;
    }

    &__description {
      @apply pt-2;
      @apply pb-4;

      @apply text-lg;
    }
  }
}
</style>
